import { BrandFamilyLine } from "@/components/brand-family";
import { Link, Outlet } from "@tanstack/react-router";
import { RootProvider } from "fumadocs-ui/provider/tanstack";
import { BrandLogo } from "@/components/brand-logo";
import { ThemeToggle } from "@/components/motion/theme-toggle";

export function MarketingLayout() {
  return (
    <RootProvider theme={{ enabled: false }} search={{ enabled: false }}>
      <div
        className="content-site font-hb min-h-screen bg-hb-page text-hb-text"
        data-content-layout="marketing"
      >
        <a
          href="#marketing-main"
          className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:bg-hb-page focus:p-4"
        >
          Skip to content
        </a>
        <header className="border-b border-hb-card">
          {/* On a phone: the logo and Start free on one row, the links on a second row that scrolls
              sideways and fades at its right edge to show there is more. On a wide screen: one row. */}
          <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-3 gap-y-3 px-6 py-4 md:flex-nowrap md:gap-x-5 md:px-10 md:py-5">
            <Link
              to="/"
              preload="intent"
              aria-label="Bavimail home"
              className="mr-auto flex items-center gap-3 text-xl font-bold text-hb-heading"
            >
              <BrandLogo className="h-5 w-auto md:h-7" />
            </Link>
            <div className="flex items-center gap-3 text-sm md:order-last md:gap-4">
              <ThemeToggle tooltip="Toggle theme" />
              <Link
                to="/login"
                preload="intent"
                className="rounded-md bg-hb-accent px-3 py-2 font-bold text-hb-accent-fg hover:opacity-90 md:px-4"
              >
                Start free
              </Link>
            </div>
            <nav
              aria-label="Main navigation"
              className="order-last flex w-full items-center gap-5 overflow-x-auto whitespace-nowrap pr-16 text-sm [mask-image:linear-gradient(to_right,#000_80%,transparent)] md:order-none md:w-auto md:overflow-visible md:pr-0 md:[mask-image:none]"
            >
              <Link
                to="/feature"
                preload="intent"
                className="hover:text-hb-heading"
                activeProps={{ className: "text-hb-accent", "aria-current": "page" }}
              >
                Features
              </Link>
              <Link
                to="/audience"
                preload="intent"
                className="hover:text-hb-heading"
                activeProps={{ className: "text-hb-accent", "aria-current": "page" }}
              >
                Audiences
              </Link>
              <Link
                to="/compare"
                preload="intent"
                className="hover:text-hb-heading"
                activeProps={{ className: "text-hb-accent", "aria-current": "page" }}
              >
                Compare
              </Link>
              <Link
                to="/blog"
                preload="intent"
                className="hover:text-hb-heading"
                activeProps={{ className: "text-hb-accent", "aria-current": "page" }}
              >
                Blog
              </Link>
              <Link to="/pricing" preload="intent" className="hover:text-hb-heading">
                Pricing
              </Link>
              <Link to="/docs" preload="intent" className="hover:text-hb-heading">
                Documentation
              </Link>
            </nav>
          </div>
        </header>
        <Outlet />
        <footer className="mt-20 border-t border-hb-card bg-hb-inset">
          <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-6 px-6 py-10 text-sm md:px-10">
            <div>
              <Link to="/" preload="intent" aria-label="Bavimail home">
                <BrandLogo variant="secondary" className="h-auto w-40 max-w-full" />
              </Link>
              <p className="mt-2 text-hb-muted">
                Email infrastructure for developers and AI agents.
              </p>
            </div>
            <nav aria-label="Footer navigation" className="flex flex-wrap gap-6">
              <Link to="/blog" preload="intent">
                Blog
              </Link>
              <Link to="/docs" preload="intent">
                Documentation
              </Link>
              <Link to="/privacy" preload="intent">
                Privacy
              </Link>
              <Link to="/terms" preload="intent">
                Terms
              </Link>
            </nav>
          </div>
          <div className="mx-auto max-w-7xl px-6 pb-8 text-sm md:px-10">
            <BrandFamilyLine
              className="text-hb-muted"
              linkClassName="underline underline-offset-2"
            />
          </div>
        </footer>
      </div>
    </RootProvider>
  );
}
